"use client";

import { createContext, useContext } from "react";

export const ExtractionAnnotationPopoverContext = createContext<(() => void) | undefined>(undefined);

export function useExtractionAnnotationPopover(): (() => void) | undefined {
  return useContext(ExtractionAnnotationPopoverContext);
}
